/**
 * @generated SignedSource<<dc53add189775e4753987d99a23a655b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EventEditType = "ALL" | "FOLLOWING" | "THIS";
export type useDeleteEventMutation$variables = {
  calendar: string;
  editType: EventEditType;
  guid: string;
};
export type useDeleteEventMutation$data = {
  readonly deleteEvent: {
    readonly event: {
      readonly guid: string;
    } | null;
  } | null;
};
export type useDeleteEventMutation = {
  response: useDeleteEventMutation$data;
  variables: useDeleteEventMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "calendar"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "editType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "guid"
},
v3 = [
  {
    "kind": "Variable",
    "name": "calendarId",
    "variableName": "calendar"
  },
  {
    "kind": "Variable",
    "name": "editType",
    "variableName": "editType"
  },
  {
    "kind": "Variable",
    "name": "guid",
    "variableName": "guid"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "guid",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useDeleteEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DeleteEventMutation",
        "kind": "LinkedField",
        "name": "deleteEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useDeleteEventMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "DeleteEventMutation",
        "kind": "LinkedField",
        "name": "deleteEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Event",
            "kind": "LinkedField",
            "name": "event",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "41720744fa5d9ac4ebad6812b5d80222",
    "id": null,
    "metadata": {},
    "name": "useDeleteEventMutation",
    "operationKind": "mutation",
    "text": "mutation useDeleteEventMutation(\n  $calendar: ID!\n  $guid: String!\n  $editType: EventEditType!\n) {\n  deleteEvent(calendarId: $calendar, guid: $guid, editType: $editType) {\n    event {\n      guid\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a2c16de7044bcc25df05f2902761068";

export default node;
